module.exports = __webpack_public_path__ + "img/ico-youtube.afee92c8.svg";